import React from 'react';
import { Helmet } from 'react-helmet';
import { motion, Variants } from 'framer-motion';

const MentionsLegales = () => {
  const fadeIn: Variants = {
    initial: {
      opacity: 0,
      y: 20
    },
    animate: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };

  const containerVariants: Variants = {
    initial: { opacity: 0 },
    animate: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }
  };

  return (
    <div className="min-h-screen pt-32 pb-16" style={{ background: 'linear-gradient(180deg, #f8fffe 0%, #eef7f5 40%, #f0f9f7 100%)' }}>
      <Helmet>
        <title>Mentions Légales - FB Conseils</title>
        <meta name="description" content="Mentions légales du site maformejuridique.fr - FB Conseils, expert en création d'entreprise. SIRET 931 237 192." />
        <link rel="canonical" href="https://maformejuridique.fr/mentions-legales" />
        <meta name="robots" content="noindex, follow" />
      </Helmet>

      <motion.div
        className="max-w-4xl mx-auto px-4 mb-20"
        initial="initial"
        animate="animate"
        variants={containerVariants}
      >
        {/* Page header */}
        <motion.div className="text-center mb-16" variants={fadeIn}>
          <span
            className="text-sm tracking-[0.25em] uppercase font-medium"
            style={{ color: '#45B8A9', fontFamily: "'Outfit', sans-serif" }}
          >
            Informations légales
          </span>
          <h1
            className="text-4xl md:text-5xl mt-4"
            style={{ color: '#003942', fontFamily: "'Cormorant', serif", fontWeight: 700 }}
          >
            Mentions Légales
          </h1>
          <div className="w-16 h-0.5 mx-auto mt-6" style={{ backgroundColor: '#45B8A9' }} />
        </motion.div>

        <div className="space-y-6">
          <motion.section
            className="bg-white rounded-2xl p-8 border border-gray-100 shadow-sm hover:shadow-lg transition-shadow duration-500"
            variants={fadeIn}
          >
            <p className="text-gray-600 leading-relaxed" style={{ fontFamily: "'Outfit', sans-serif" }}>
              Conformément aux dispositions de la loi n° 2004-575 du 21 juin 2004 pour la confiance en l'économie numérique,
              il est précisé aux utilisateurs du site Maformejuridique.fr l'identité des différents intervenants dans le cadre
              de sa réalisation et de son suivi.
            </p>
          </motion.section>

          <motion.section
            className="bg-white rounded-2xl p-8 border border-gray-100 shadow-sm hover:shadow-lg transition-shadow duration-500"
            variants={fadeIn}
          >
            <h2 className="text-2xl mb-6" style={{ color: '#003942', fontFamily: "'Cormorant', serif", fontWeight: 700 }}>
              Edition du site
            </h2>
            <div className="pl-4 border-l-[3px] space-y-4" style={{ borderColor: 'rgba(69,184,169,0.3)' }}>
              <p className="text-gray-600" style={{ fontFamily: "'Outfit', sans-serif" }}>
                Le présent site, accessible à l'URL Https://maformejuridique.fr (le « Site »), est édité par :
              </p>
              <div className="space-y-2">
                <p className="text-gray-600" style={{ fontFamily: "'Outfit', sans-serif" }}>
                  Fb conseils, société au capital de 500 euros, inscrite au R.C.S. de ROMANS sous le numéro 931237192,
                  dont le siège social est situé au 17 allée des chataigniers 26600 beaumont-monteux,
                  représenté(e) par Fannie Rey dûment habilité(e)
                </p>
                <p className="text-gray-600" style={{ fontFamily: "'Outfit', sans-serif" }}>
                  Le numéro individuel TVA de l'éditeur est : Fr38931237192.
                </p>
              </div>
            </div>
          </motion.section>

          <motion.section
            className="bg-white rounded-2xl p-8 border border-gray-100 shadow-sm hover:shadow-lg transition-shadow duration-500"
            variants={fadeIn}
          >
            <h2 className="text-2xl mb-6" style={{ color: '#003942', fontFamily: "'Cormorant', serif", fontWeight: 700 }}>
              Hébergement
            </h2>
            <div className="pl-4 border-l-[3px]" style={{ borderColor: 'rgba(69,184,169,0.3)' }}>
              <p className="text-gray-600" style={{ fontFamily: "'Outfit', sans-serif" }}>
                Le Site est hébergé par la société Hostinger International LTD, situé,
                (contact téléphonique ou email : https://www.hostinger.fr/contact).
              </p>
            </div>
          </motion.section>

          <motion.section
            className="bg-white rounded-2xl p-8 border border-gray-100 shadow-sm hover:shadow-lg transition-shadow duration-500"
            variants={fadeIn}
          >
            <h2 className="text-2xl mb-6" style={{ color: '#003942', fontFamily: "'Cormorant', serif", fontWeight: 700 }}>
              Directeur de publication
            </h2>
            <div className="pl-4 border-l-[3px]" style={{ borderColor: 'rgba(69,184,169,0.3)' }}>
              <p className="text-gray-600" style={{ fontFamily: "'Outfit', sans-serif" }}>
                Le Directeur de la publication du Site est Fannie Rey.
              </p>
            </div>
          </motion.section>

          <motion.section
            className="bg-white rounded-2xl p-8 border border-gray-100 shadow-sm hover:shadow-lg transition-shadow duration-500"
            variants={fadeIn}
          >
            <h2 className="text-2xl mb-6" style={{ color: '#003942', fontFamily: "'Cormorant', serif", fontWeight: 700 }}>
              Nous contacter
            </h2>
            <div className="pl-4 border-l-[3px] space-y-2" style={{ borderColor: 'rgba(69,184,169,0.3)' }}>
              <p className="text-gray-600" style={{ fontFamily: "'Outfit', sans-serif" }}>Par téléphone : +33672589565</p>
              <p className="text-gray-600" style={{ fontFamily: "'Outfit', sans-serif" }}>Par email : fbsimulateurs@gmail.com</p>
              <p className="text-gray-600" style={{ fontFamily: "'Outfit', sans-serif" }}>Par courrier : 17 allée des chataigniers 26600 beaumont-monteux</p>
            </div>
          </motion.section>

          <motion.section
            className="bg-white rounded-2xl p-8 border border-gray-100 shadow-sm hover:shadow-lg transition-shadow duration-500"
            variants={fadeIn}
          >
            <h2 className="text-2xl mb-6" style={{ color: '#003942', fontFamily: "'Cormorant', serif", fontWeight: 700 }}>
              Données personnelles
            </h2>
            <div className="pl-4 border-l-[3px]" style={{ borderColor: 'rgba(69,184,169,0.3)' }}>
              <p className="text-gray-600" style={{ fontFamily: "'Outfit', sans-serif" }}>
                Le traitement de vos données à caractère personnel est régi par notre Charte du respect de la vie privée,
                disponible depuis la section "Charte de Protection des Données Personnelles", conformément au Règlement
                Général sur la Protection des Données 2016/679 du 27 avril 2016 («RGPD»).
              </p>
            </div>
          </motion.section>

          <motion.div
            className="text-sm text-gray-400 text-center mt-8"
            variants={fadeIn}
            style={{ fontFamily: "'Outfit', sans-serif" }}
          >
            Génération des mentions légales par Legalstart.
          </motion.div>
        </div>
      </motion.div>
    </div>
  );
};

export default MentionsLegales;
